import { DataSource } from 'types/datasource';
import { TasticProps } from '../../types';
import { Module07, Module07Props } from 'components/gruenland/organisms/mod07NewIn/Module07';
import { Product } from 'shared/types/product';

const NewInTastic = ({ data }: TasticProps<DataSource<{ items: Product[] }> & Module07Props>) => {
  return (
    <Module07
      title={data.title}
      image={data.image}
      imageLg={data.imageLg}
      layoutVariant={data.layoutVariant}
      products={data.data?.dataSource?.items ?? []}
    />
  );
};
export default NewInTastic;
